export default __webpack_public_path__ + "static/media/weibo.aea0148f.svg";